import { useState } from 'react';
import classNames from 'classnames';
import paLogo from '../assets/logos/CyrenCare for patients.svg';

interface LogoPatientDynamicProps {
  logoUrl?: string | null;
  isLoading?: boolean;
  className?: string;
}

export default function LogoPatientDynamic({
  logoUrl,
  isLoading = false,
  className,
}: LogoPatientDynamicProps) {
  const [imageError, setImageError] = useState(false);

  const handleImageError = () => {
    // If org logo fails to load, fall back to CyrenCare logo
    setImageError(true);
  };

  // Show skeleton UI while loading
  if (isLoading) {
    return (
      <div
        className={classNames('w-8 h-8 bg-gray-200 animate-pulse rounded', className)}
        aria-label='로고 로딩 중'
      />
    );
  }

  // Only show logo if organization logo is available and loaded successfully
  // If no logoUrl or image failed to load, show nothing
  if (!logoUrl || imageError) {
    return <div className={classNames('w-8 h-8', className)} />;
  }

  return (
    <img
      src={logoUrl}
      alt={logoUrl && !imageError ? 'organization logo' : 'cyrencare for patient'}
      className={classNames('w-8 h-8 aspect-auto', className)}
      onError={handleImageError}
    />
  );
}
